import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { TramiteStatus } from './tramite-status.model';

export const entityTramiteStatusAdapter: EntityAdapter<TramiteStatus> =
  createEntityAdapter<TramiteStatus>({
    selectId: (model) => `${model.estado_id}-${model.sistema_id}`,
    sortComparer: (a: TramiteStatus, b: TramiteStatus): number =>
      a.estado_nombre.localeCompare(b.estado_nombre),
  });

export interface EntityTramiteStatusState extends EntityState<TramiteStatus> {
  loaded?: boolean;
  isLoading: boolean;
  error?: Error | null;
}

export const initialState: EntityTramiteStatusState =
  entityTramiteStatusAdapter.getInitialState({
    isLoading: false,
    error: null
  });
